import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CardHover from 'components/Panels/CardHover/CardHover';
import PopOverStickOnHover from 'components/PopOverStickOnHover/PopOverStickOnHover';
import actions from 'actions';
import sh from 'components/shared.module.css';
import Bucket from './Bucket';
import EntityCard from './EntityCard/EntityCard';

const { requestMainViewCards } = actions;

const genCards = (data, bucketId, viewOption) => {
  const cards = data.buckets[bucketId];
  return (
    Object.keys(cards).map(id => (
      /* extend PopOverStickOnHover to request with card
      Id before showing CardHover */
      <PopOverStickOnHover
        component={<CardHover />}
        placement='auto'
        onMouseEnter={() => { }}
        delay={1000}
        key={`overlay-${id}`}
      >
        <div><EntityCard {...{ viewOption }} key={id} title={cards[id].title} img={cards[id].img} /></div>
      </PopOverStickOnHover>
    ))
  );
};

const genBucketsWithCards = (data, viewOption) => {
  if (!data || !data.buckets) return '';

  const buckets = Object.keys(data.buckets).length;
  if (buckets === 0) { return ''; }

  if (buckets === 1) {
    return (
      <div className='d-flex justify-content-center align-content-around flex-wrap'>
        {genCards(data, '1', viewOption)}
      </div>
    );
  }

  return Object.keys(data.buckets)
    .map(bucketId =>
      <Bucket>{genCards(data, bucketId, viewOption)}</Bucket>);
};

// https://walterebert.com/blog/using-the-picture-element-to-load-webp-images-with-fallback/
const PaginationBody = ({ tabId, mapIsAvailiable }) => {
  const dispatch = useDispatch();
  // todo: pass view option state to gen
  const cards = useSelector(state => genBucketsWithCards(state.cards, state.tabs[tabId].viewOption));
  useEffect(() => {
    if (!cards) {
      dispatch(requestMainViewCards());
    }
  }, [dispatch, cards]);

  return (
    <div className={`${mapIsAvailiable ? sh.fixSidePanelScrollbarWithMap : sh.fixSidePanelScrollbar}`}>
    {/* <div className={sh.fixSidePanelScrollbar}> */}
      {cards}
    </div>
  );


};

export default PaginationBody;
